import { Directive, ElementRef, Input, inject } from '@angular/core';

@Directive({
  selector: '[injectHTML]',
  standalone: true,
})
export class InjectHTMLDirective {
  private host = inject(ElementRef);

  @Input() set injectHTML(content: string) {
    this.host.nativeElement.innerHTML = content;
  }

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}
}
